import type { SxProps, Theme } from '@mui/material/styles';
import { noop } from '@src/utils';
import React from 'react';

import FormBase from '../base/Form';
import { FormProvider } from './FormContext';
import useForm from './useForm';

interface GenericFormProps {
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  onSubmit?: (values: Record<string, unknown>) => unknown;
  onSuccess?: (response: unknown) => void;
  onError?: (error: unknown, info: { isInvalid: boolean }) => void;
  onInvalid?: () => void;
  schema?: unknown;
  defaultValues?: Record<string, unknown>;
  showServerErrors?: boolean;
}

const Form = React.forwardRef<HTMLFormElement, GenericFormProps>((props, ref) => {
  const {
    sx,
    children,
    onSubmit = noop as GenericFormProps['onSubmit'],
    onSuccess = noop as GenericFormProps['onSuccess'],
    onError = noop as GenericFormProps['onError'],
    onInvalid = noop,
    ...restProps
  } = props;

  const { handleSubmit, ...form } = useForm(restProps as Record<string, unknown>);

  return (
    <FormProvider form={{ handleSubmit, ...form }}>
      <FormBase
        ref={ref}
        sx={sx}
        onSubmit={handleSubmit({ onSubmit, onSuccess, onError, onInvalid })}
      >
        {children}
      </FormBase>
    </FormProvider>
  );
});

Form.displayName = 'FormGeneric';
export default Form;
